import React, { Component } from 'react';
import { Label, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import cx from 'classnames';

import styles from '../form.module.scss';

class Checkbox extends Component {
  render() {
    var { label, className, type, ...props } = this.props;
    const isCheckbox = type === 'checkbox';

    className = cx(styles.checkbox, className);

    return (
      <Label check className={className}>
        <Input type={type} {...props} />
        <MaterialIcon
          icon={cx({
            check_box_outline_blank: isCheckbox && !props.checked,
            check_box: isCheckbox && props.checked,
            radio_button_unchecked: !isCheckbox && !props.checked,
            radio_button_checked: !isCheckbox && props.checked
          })}
          color="inherit"
        />{' '}
        {label}
      </Label>
    );
  }
}

Checkbox.defaultProps = {
  type: 'checkbox'
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/form/field/checkbox.js